import React, { createContext, ReactNode, useCallback, useMemo, useState } from 'react';
import { useSecurityContext } from '../../../security/hook/useSecurityContext';
import { useCreateRequestAPI } from '../../../api/request/useCreateRequestAPI';

import { ChatRequest } from '../../../type/request/ChatRequest';

export interface ICreateRequestContext {
    createRequest: (request: ChatRequest) => Promise<void>;
    createdRequest: ChatRequest;
    setCreatedRequests: () => void;
}

interface CreateRequestProviderProps {
    children: ReactNode;
}

export const CreateRequestContext: React.Context<any> = createContext<ICreateRequestContext | undefined>(undefined);

export const CreateRequestProvider = ({ children }: CreateRequestProviderProps) => {
    const { user: authenticatedUser } = useSecurityContext();
    const [createdRequest, setCreatedRequests] = useState();
    const { createRequestAPI } = useCreateRequestAPI();

    const createRequest = useCallback(
        async (request: ChatRequest): Promise<void> => {
            const newRequest = await createRequestAPI(authenticatedUser?.user, request);
            setCreatedRequests(newRequest);
        },
        [authenticatedUser, createRequestAPI]
    );

    const value = useMemo(() => {
        return {
            createRequest,
            createdRequest,
            setCreatedRequests,
        };
    }, [createRequest, createdRequest]);

    return <CreateRequestContext.Provider value={value}>{children}</CreateRequestContext.Provider>;
};
